'use strict';

module.exports = /(^|_)([^_]+)/g;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/string/var/CAMELIZE_REG.js
// module id = 939
// module chunks = 0